import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { AuthShell } from "../components/AuthShell";
import { publicApi, errMsg } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await publicApi.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };

  if (sent) {
    return (
      <AuthShell testid="forgot-sent">
        <MailCheck size={44} />
        <h1 className="text-3xl font-bold">Check your inbox</h1>
        <p className="text-[#1B1A2E]/75">If a Zunii account exists for <b className="break-all">{email}</b>, we've sent a link to reset your password. It expires in 1 hour.</p>
        <p className="text-sm text-[#1B1A2E]/60">Don't see it? Check your spam folder.</p>
        <Link to="/login" data-testid="forgot-back-login" className="zn-btn bg-white w-full">Back to log in</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell testid="forgot-form-card">
      <h1 className="text-3xl sm:text-4xl font-bold">Forgot password?</h1>
      <p className="text-[#1B1A2E]/70">Enter your parent email and we'll send you a reset link.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
        <input data-testid="forgot-email-input" type="email" inputMode="email" autoComplete="email" autoCapitalize="none" className="zn-input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        {err && <p data-testid="forgot-error" className="text-[#E8442A] font-semibold text-sm">{err}</p>}
        <button data-testid="forgot-submit-btn" disabled={busy || !email} className="zn-btn bg-[#FF6B4A] text-white w-full text-lg">{busy ? "Sending…" : "Send reset link"}</button>
      </form>
      <p className="text-sm text-center"><Link to="/login" data-testid="forgot-login-link" className="font-bold underline decoration-[#7B5CFA] decoration-2 underline-offset-4">Back to log in</Link></p>
    </AuthShell>
  );
}
